import { put, takeLatest, call, takeEvery, select } from "redux-saga/effects";
import * as types from "../constants/DashboardActionTypes";
import reportsService from "../../services/reportsService";

function* fetchDashboardData() {
  try {
    let { data } = yield call(reportsService.getDashboardReports);
    yield put({
      type: types.DASHBOARD_FETCHED,
      data
    });
  } catch (err) {
    yield put({
      type: types.DASHBOARD_FAILED
    });
  }
}

//watchers
function* fetchDashboardDataWatcher() {
  yield takeEvery(types.DASHBOARD_FETCHING, fetchDashboardData);
}

export default {
  fetchDashboardDataWatcher
};
